export default "__VITE_ASSET__DhDcPlNt__"